import { render, staticRenderFns } from "./BranchRow.vue?vue&type=template&id=2859756e&"
import script from "./BranchRow.vue?vue&type=script&lang=js&"
export * from "./BranchRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports